export interface AddPhoto {
    fileName: string;
    fileType: string;
    photoData: string;
}
